import React, { useEffect, useState } from 'react'
import './PricingCard.css';
import logo from '../../logo.svg';
import { Link } from 'react-router-dom';
import PackageData from '../additional/PackagesData'
import Toast from './Toast';

const PricingCard = () => {

    const [isSuccess, setSuccess] = useState(false);
    const [message, setMessage] = useState('Success');

    useEffect(() => {
        const interval = setInterval(() => setSuccess(false), 7000);
        return () => {
        clearInterval(interval);
        };
    }, []);

    const loadScript = (src) =>{
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.src = src;

            script.onload = () => {
                resolve(true);
            }

            script.onerror = () => {
                resolve(false);
            }

            document.body.appendChild(script);
        })
    }


    const displayRazorPay = async (val) => {
        const amount = val.price;
        console.log("razor....")
        const res = await loadScript('https://checkout.razorpay.com/v1/checkout.js');

        if(!res){
            alert('You are offline... failed to load Razorpay SDK')
            return;
        }else{
            console.log("success.....");
        }

        const options = {
            key: "rzp_test_AMdSMiXltTQJ1l",
            currency: "INR",
            amount: amount * 100,
            name: "Pankaj Menariya",
            description: "You have purchased " + val.type + " package.",
            image: {logo},
            handler: function (response) {
                setSuccess(true)
                setMessage("You have purchased " + val.type + " package.");
                // alert(response.razorpay_payment_id)
                // alert("payment successfull")
            },

            // if(response.razorpay_payment_id)// database api call

            prefill:{
                name:"Pankaj Menariya"
            }
        };

        const paymentObject = new window.Razorpay(options)
        paymentObject.open();
    }

    const notify = () =>{
        setSuccess(true)
        setMessage('payment done');
    }
    
  return (
    <div className='pricing'>
        <div className='card-container'>
            {
                PackageData.map((val, ind) => {
                    return(
                        <div key={ind} className='card'>
                            <h3>- {val.type} -</h3>
                            <span className='bar'></span>
                            <p className='btc'>&#8377; {val.price}</p>
                            <p>- {val.time} -</p>
                            <p>- {val.size} -</p>
                            <p>- Featured -</p>
                            <p>- Responsive Design -</p>
                            <Link className='btn' onClick={()=>displayRazorPay(val)}>
                                PURCHASE NOW
                            </Link>
                        </div>
                    )
                })
            }
        </div>
        {isSuccess ? <Toast message={message}/> : ''}
    </div>
  )
}

export default PricingCard